import React from 'react';

const Icon = ({ size = '29', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 29 29" fill="none" {...other}>
            <path
                d="M9.086 24.587h-5.5l1.366-3.513h4.866l-.732 3.513Zm10.05 0h-8.854l.732-3.513h7.39l.733 3.513Zm6.696 0h-5.5l-.733-3.513h4.867l1.366 3.513Zm-15.77-4.683H5.406l.911-2.343h4.232l-.489 2.343Zm8.099 0h-6.903l.488-2.343h5.927l.488 2.343Zm5.85 0h-4.655l-.488-2.343h4.231l.912 2.343Zm-13.218-3.513h-4.02l.91-2.341h3.598l-.488 2.341Zm6.636 0h-5.44l.488-2.341h4.463l.488 2.341Zm5.215 0h-4.02l-.487-2.341h3.596l.911 2.341ZM16.967 6.257l3.537-.344-.344 3.537 2.744 2.259-1.423 1.17h-2.675a4.1 4.1 0 0 0-6.996-2.898 4.102 4.102 0 0 0-1.2 2.899H7.935l-1.423-1.171 2.745-2.26-.344-3.536 3.537.344 2.259-2.745 2.258 2.745Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
